const PICKUP = 'filters[Pickup]';
const SAME_DAY = 'filters[SameDay]';
const PICKUP_FILTER_START = 'filters[Pickup]';
const SAME_DAY_FILTER_START = 'filters[SameDay]';

module.exports = {
    PICKUP,
    SAME_DAY,
    PICKUP_FILTER_START,
    SAME_DAY_FILTER_START
};
